/* eslint-disable react-hooks-extra/no-direct-set-state-in-use-effect */
import type { HTMLAttributes } from 'react';

import { Label } from '@connected/ui/components/label';
import { Switch as PrimitiveSwitch } from '@connected/ui/components/switch';
import { cn } from '@connected/ui/lib/utils';
import { useEffect, useState } from 'react';

import type { PrimativeFieldProps, PrimativeFormPropsOmit, PrimativeLabelType } from '../../lib/utils';

export type SwitchProps = Omit<HTMLAttributes<HTMLDivElement>, PrimativeFormPropsOmit> & PrimativeFieldProps<boolean | null> & {
    label?: PrimativeLabelType;
    disabled?: boolean;
};

export function Switch(props: SwitchProps) {
    const { name, value, onChange, onBlur, label, className, disabled, id, ...restProps } = props;

    const [checked, setChecked] = useState(value);

    useEffect(() => {
        setChecked(!!value);
    }, [value]);

    function handleCheckedChange(checked: boolean) {
        onChange(checked);
    }

    return (
        <div className={cn('flex items-center gap-2', className)} {...restProps}>
            <PrimitiveSwitch
                id={id ?? name}
                name={name}
                checked={checked ?? false}
                onCheckedChange={handleCheckedChange}
                onBlur={onBlur}
                disabled={disabled}
            />
            {label && <Label htmlFor={id ?? name} disabled={disabled}>{label}</Label>}
        </div>
    );
}

Switch.displayName = 'Switch';
